<template>
  <section v-if="enabled">
    <aside class="sidebar" :style="style" ref="profileElement">
      <slot></slot>
    </aside>
    <div class="overlay" id="profile_drawer_overlay" ref="profileOverlay" @click="close"></div>
  </section>
</template>
<script>
import eventBus from '../../event-bus';

export default {
  props: ['direction', 'exist'],
  data() {
    return {
      auto_speed: '0.3s',
      manual_speed: '0.03s',
      threshold: 20,
      startTime: null,
      startPos: null,
      translate: null,
      active: false,
      visible: true,
    };
  },
  computed: {
    profileElement() {
      return this.$refs.profileElement;
    },
    profileOverlay() {
      return this.$refs.profileOverlay;
    },
    enabled() {
      return this.exist === true;
    },
    style() {
      if (this.direction === 'right') {
        if (this.$attrs.styles) {
          return 'transform:translate3d(100%,0,0);right:0;width: 45.25vw;';
        }
        return 'transform:translate3d(100%,0,0);right:0;';
      }
      return 'transform:translate3d(-100%,0,0);left:0;';
    },
  },
  beforeDestroy() {
    eventBus.$offOwner(this);
  },
  mounted() {
    eventBus.$on(
      'uncompleted-appointment-edit-begin',
      (event) => {
        this.appointment_being_edited = true;
      },
      this,
    );

    eventBus.$on(
      'uncompleted-appointment-edit-stop',
      (event) => {
        this.appointment_being_edited = false;
      },
      this,
    );
  },
  methods: {
    overlayOpacity(opacity) {
      this.profileOverlay.style.opacity = opacity;
      if (opacity > 0) {
        this.profileOverlay.style.zIndex = 99999;
      }
    },
    open() {
      this.translate = 0;
      this.$refs.profileOverlay.style.display = 'block';
      this.profileElement.style.transform = `translate3d(${this.translate},0,0)`;
      this.profileElement.style.transitionDuration = this.auto_speed;
      this.overlayOpacity(1);
      this.profileElement.classList.add('active');
      this.active = false;
      eventBus.$emit('profile-drawer-opened', {});
    },
    close() {
      if (this.appointment_being_edited) {
        const title = 'Tab close';
        eventBus.$emit('confirmAppointmentOutstandingChangesSave', { title });
      } else {
        if (this.direction === 'left') {
          this.translate = `-${this.profileElement.offsetWidth}px`;
        } else {
          this.translate = `${this.profileElement.offsetWidth}px`;
        }
        this.profileElement.style.transform = `translate3d(${this.translate},0,0)`;
        this.profileElement.style.transitionDuration = this.auto_speed;
        this.overlayOpacity(0);
        this.$refs.profileOverlay.style.display = 'none';
        this.profileElement.classList.remove('active');
        this.active = false;
        eventBus.$emit('profile-drawer-closed', {});
      }
    },
  },
};
</script>
<style scoped>
div.overlay {
  display: none;
  position: fixed;
  z-index: -999;
  left: 0px;
  top: 0px;
  background: rgba(11, 10, 12, 0.35);
  opacity: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s ease;
}
aside.sidebar {
  z-index: 999999;
  position: fixed;
  will-change: transform;
  height: 100%;
  top: 0px;
  transition: transform 0.3s ease;
  background: #fff;
  overflow-y: hidden;
  overflow-x: hidden;
  word-wrap: break-word;
  right: -100% !important;
  width: 91.5vw;
}
aside.sidebar.active {
  right: 0 !important;
}
</style>
